import { Routes } from '@angular/router';
import { EditPageComponent } from './edit-page/edit-page.component';
import { AuthGuard } from '../../../guards/auth.guard';
import { IsCompletedUserDataGuard } from '../../../guards/is-completed-user-data.guard';
import { opinionOfConformityRoutes } from './opinion-of-conformity/opinion-of-conformity.routes';
import {
  irspaApplicationForTheProjectRoutes
} from './irspa-application-for-the-project/irspa-application-for-the-project.routes';
import { irspaAmendTheActRoutes } from './irspa-amend-the-act/irspa-amend-the-act.routes';
import {
  irspaWarningOnTheConsultedDraftRoutes
} from './irspa-warning-on-the-consulted-draft/irspa-warning-on-the-consulted-draft.routes';
import {
  irspaPreparationOfTheActRoutes
} from './irspa-preparation-of-the-act/irspa-preparation-of-the-act.routes';
import {
  certAboutConformityOfUseWithMpzpRoutes
} from './cert-about-conformity-of-use-with-mpzp/cert-about-conformity-of-use-with-mpzp.routes';
import {
  wExtractAndDraftFromStudyRoutes
} from './w-extract-and-draft-from-study/w-extract-and-draft-from-study.routes';
import { wExtractAndDraftMpzpRoutes } from './w-extract-and-draft-mpzp/w-extract-and-draft-mpzp.routes';
import {
  wCertificateFromMunicipalRegisterRoutes
} from './w-certificate-from-municipal-register/w-certificate-from-municipal-register.routes';
import {
  wLocationPropertyInRevitalizationAreaRoutes
} from './w-location-property-in-revitalization-area/w-location-property-in-revitalization-area.routes';
import { responseToCallRoutes } from './response-to-call/response-to-call.routes';
import { generalLetterRoutes } from './general-letter/general-letter.routes';
import { documentsInformationRoutes } from './documents-information/documents-information.routes';
import {
  certAboutConformityOfStudyRoutes
} from './cert-about-conformity-of-study/cert-about-conformity-of-study.routes';
import { leaseOfABurialPlaceRoutes } from './lease-of-a-burial-place/lease-of-a-burial-place.routes';
import {
  applicationForACemeterySpaceRoutes
} from './application-for-a-cemetery-space/application-for-a-cemetery-space.routes';
import {
  registrationForTheSewageTreatmentRoutes
} from './registration-for-the-sewage-treatment-plant-register/registration-for-the-sewage-treatment-plant-register.routes';
import {
  wDeterminingPlanningFeeBeforeSaleOfPropertyRoutes
} from './w-determining-planning-fee-before-sale-of-property/w-determining-planning-fee-before-sale-of-property.routes';
import {
  submittingAnInvestorLetterOfIntentRoutes
} from './submitting-an-investor-letter-of-intent/submitting-an-investor-letter-of-intent.routes';
import { generalApplicationRoutes } from './general-application/general-application.routes';
import { removalOfTreesOrShrubsRoutes } from './removal-of-trees-or-shrubs/removal-of-trees-or-shrubs.routes';
import { municipalWasteDisposalRoutes } from './municipal-waste-disposal/municipal-waste-disposal.routes';
import {
  coordinatingTrafficOrganizationProjectsRoutes
} from './coordinating-traffic-organization-projects/coordinating-traffic-organization-projects.routes';
import {
  decisionOnDevelopmentConditionsRoutes
} from './decision-on-development-conditions/decision-on-development-conditions.routes';
import {
  opinionOfConformityOfPropertyDivisionMpzpRoutes
} from './opinion-of-conformity-of-property-division-mpzp/opinion-of-conformity-of-property-division-mpzp.routes';
import {
  decisionOnDeterminingTheLocationOfAPublicPurposeInvestmentRoutes
} from './decision-on-determining-the-location-of-a-public-purpose-investment/decision-on-determining-the-location-of-a-public-purpose-investment.routes';

export const applicationEditPageRoutes: Routes = [
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/odpowiedz-na-wezwanie',
    children: responseToCallRoutes,
    data: {
      contentUrl: 'odpowiedz-na-wezwanie'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/uzupelnienie-dokumentow',
    children: documentsInformationRoutes,
    data: {
      contentUrl: 'uzupelnienie-dokumentow'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/pismo-ogolne',
    children: generalLetterRoutes,
    data: {
      contentUrl: 'pismo-ogolne'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/ustalenie-numeru-porzadkowego',
    children: wLocationPropertyInRevitalizationAreaRoutes,
    data: {
      contentUrl: 'ustalenie-numeru-porzadkowego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/zaswiadczenie-z-gminnej-ewidencji-zabytkow',
    children: wCertificateFromMunicipalRegisterRoutes,
    data: {
      contentUrl: 'zaswiadczenie-z-gminnej-ewidencji-zabytkow'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/wypis-i-wyrys-z-mpzp',
    children: wExtractAndDraftMpzpRoutes,
    data: {
      contentUrl: 'wypis-i-wyrys-z-mpzp'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/wypis-i-wyrys-ze-studium',
    children: wExtractAndDraftFromStudyRoutes,
    data: {
      contentUrl: 'wypis-i-wyrys-ze-studium'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/zaswiadczenie-z-mpzp',
    children: certAboutConformityOfUseWithMpzpRoutes,
    data: {
      contentUrl: 'zaswiadczenie-z-mpzp'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/zaswiadczenie-ze-studium',
    children: certAboutConformityOfStudyRoutes,
    data: {
      contentUrl: 'zaswiadczenie-ze-studium'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/wniosek-do-projektu-aktu-planowania-przestrzennego',
    children: irspaApplicationForTheProjectRoutes,
    data: {
      contentUrl: 'wniosek-do-projektu-aktu-planowania-przestrzennego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/opinia-o-zgodnosci-realizacji-obiektow-z-uchwala-krajobrazowa',
    children: opinionOfConformityRoutes,
    data: {
      contentUrl: 'opinia-o-zgodnosci-realizacji-obiektow-z-uchwala-krajobrazowa'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/uwaga-do-konsultowanego-projaktu-aktu-planowania-przestrzennego',
    children: irspaWarningOnTheConsultedDraftRoutes,
    data: {
      contentUrl: 'uwaga-do-konsultowanego-projaktu-aktu-planowania-przestrzennego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/wniosek-o-zmiane-aktu-planowania-przestrzennego',
    children: irspaAmendTheActRoutes,
    data: {
      contentUrl: 'wniosek-o-zmiane-aktu-planowania-przestrzennego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/wniosek-o-sporządzenie-aktu-planowania-przestrzennego',
    children: irspaPreparationOfTheActRoutes,
    data: {
      contentUrl: 'wniosek-o-sporządzenie-aktu-planowania-przestrzennego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/wniosek-o-dzierzawe-miejsca-grzebalnego',
    children: leaseOfABurialPlaceRoutes,
    data: {
      contentUrl: 'wniosek-o-dzierzawe-miejsca-grzebalnego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/wniosek-o-miejsce-na-cmentarzu',
    children: applicationForACemeterySpaceRoutes,
    data: {
      contentUrl: 'wniosek-o-miejsce-na-cmentarzu'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/zgloszenie-do-ewidencji-przydomowych-oczyszczalni-sciekow',
    children: registrationForTheSewageTreatmentRoutes,
    data: {
      contentUrl: 'zgloszenie-do-ewidencji-przydomowych-oczyszczalni-sciekow'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/ustalenie-oplaty-planistycznej-przed-zbyciem-nieruchomosci',
    children: wDeterminingPlanningFeeBeforeSaleOfPropertyRoutes,
    data: {
      contentUrl: 'ustalenie-oplaty-planistycznej-przed-zbyciem-nieruchomosci'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/zlozenie-listu-intencyjnego-inwestora',
    children: submittingAnInvestorLetterOfIntentRoutes,
    data: {
      contentUrl: 'zlozenie-listu-intencyjnego-inwestora'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/wniosek-ogolny',
    children: generalApplicationRoutes,
    data: {
      contentUrl: 'wniosek-ogolny'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/wniosek-o-wydanie-zezwolenia-na-usuniecie-drzew-lub-krzewow',
    children: removalOfTreesOrShrubsRoutes,
    data: {
      contentUrl: 'wniosek-o-wydanie-zezwolenia-na-usuniecie-drzew-lub-krzewow'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/deklaracja-o-wysokosci-oplaty-za-gospodarowanie-odpadami-komunalnymi',
    children: municipalWasteDisposalRoutes,
    data: {
      contentUrl: 'deklaracja-o-wysokosci-oplaty-za-gospodarowanie-odpadami-komunalnymi'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/opiniowanie-i-uzgadnianie-projektow-stalej-lub-czasowej-organizacji-ruchu',
    children: coordinatingTrafficOrganizationProjectsRoutes,
    data: {
      contentUrl: 'opiniowanie-i-uzgadnianie-projektow-stalej-lub-czasowej-organizacji-ruchu'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/decyzja-o-warunkach-zabudowy',
    children: decisionOnDevelopmentConditionsRoutes,
    data: {
      contentUrl: 'decyzja-o-warunkach-zabudowy'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/wniosek-o-opinie-zgodnosci-podzialu-nieruchomosci-z-mpzp',
    children: opinionOfConformityOfPropertyDivisionMpzpRoutes,
    data: {
      contentUrl: 'wniosek-o-opinie-zgodnosci-podzialu-nieruchomosci-z-mpzp'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/decyzja-o-ustalenie-lokalizacji-inwestycji-celu-publicznego',
    children: decisionOnDeterminingTheLocationOfAPublicPurposeInvestmentRoutes,
    data: {
      contentUrl: 'decyzja-o-ustalenie-lokalizacji-inwestycji-celu-publicznego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  }
];
